import { Card } from "antd";
const { Meta } = Card;

const FeatureCard = ({ feature, customClassName }) => (
  <Card
    key={feature.id}
    className={
      "w-full h-full shadow-md rounded-xl max-w-md mx-auto max-h-xl" +
      customClassName
    }
    cover={
      <img
        alt={feature.title}
        className="object-contain w-full"
        src={`/media/${feature.image}`}
      />
    }
    hoverable={true}
  >
    <Meta
      title={<h3 className="text-xl">{feature.title}</h3>}
      description={
        <p className="text-lg text-gray-600 mt-2 leading-8 font-sans">
          {feature.description}
        </p>
      }
    />
  </Card>
);
export default FeatureCard;
